export default __webpack_public_path__ + "static/media/img-0034.403fa376.png";